import { TReduxActions } from '../../../types/redux';
import { TIsAnonymous } from '../../../types/newReview';
import { ENewReviewForm } from '../../../actions/newReview/newReviewsAction';
import { EAnonymousActionTypes } from '../../../actions/newReview/isAnonymousActions';

export const defaultValue = {
  value: null,
};

export function isAnonymousReviewReducer(
  state: TIsAnonymous = defaultValue,
  { type, payload }: TReduxActions,
): TIsAnonymous {
  if (type === EAnonymousActionTypes.Set) {
    return {
      value: payload,
    };
  }

  if (type === ENewReviewForm.Clear) {
    return defaultValue;
  }

  return state;
}
